import React, { useEffect } from 'react';

import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import useUserData from '../../hooks/useUserData';

export default function ProtectedRoute({ roles }) {
  const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

  const navigate = useNavigate();

  const { user, isFetched } = useUserData();

  useEffect(() => {
    if (
      !isLoading &&
      !isAuthenticated &&
      !window.location.search.includes('code=')
    ) {
      loginWithRedirect();
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  useEffect(() => {
    if (
      user &&
      isAuthenticated &&
      roles &&
      !roles.includes(user.role) &&
      !user.isSuper
    ) {
      navigate('/');
    }
  }, [isAuthenticated, navigate, roles, user]);

  if (isLoading || !isAuthenticated || !isFetched) {
    return <div>Loading...</div>;
  }

  return <Outlet />;
}
